import { render, staticRenderFns } from "./BottomNavigationBar.vue?vue&type=template&id=6a496f7e"
import script from "./BottomNavigationBar.vue?vue&type=script&lang=js"
export * from "./BottomNavigationBar.vue?vue&type=script&lang=js"
import style0 from "./BottomNavigationBar.vue?vue&type=style&index=0&id=6a496f7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports